import { isActivityOnly } from '@/helpers/cart';
import { TransferProductType } from '@/helpers/transfer/transfer.interfaces';
import { Cart, ProductType } from '@/api/Cart/cart.interfaces';
import store from '@/store';
import { feature } from '@libs/utils/feature/feature';

const isActivityEnabled = () => {
    if (!feature('transfer-activities')) {
        return false;
    }

    const cart: Cart = store.state.cart?.data;

    if (!cart) {
        return false;
    }

    const mainProducts = store.getters['cart/getMainProducts'];
    return isActivityOnly(cart) && mainProducts.length === 1;
};

export const getSupportedDynamicConnectionProducts = () => {
    return [
        TransferProductType.Hotel,
        ...(isActivityEnabled() ? [TransferProductType.Activity] : []),
    ];
};

export const getSupportedTransferTypes = () => {
    return [
        ProductType.Flight,
        ProductType.Hotel,
        ProductType.Ferry,
        ...(isActivityEnabled() ? [ProductType.Activity] : []),
    ];
};
